import { mapHistoryAction } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageKYC/ReviewKycWorkflow/component/StepContent/component/RightPanel/component/History/utils/mapHistoryAction';
import { HistoryEventResult } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageKYC/ReviewKycWorkflow/component/StepContent/component/RightPanel/types';
import { DATE_FORMATS, formatDateToUI } from '@dealstack/shared/lib/format/dates/date';
import { DocumentSigningRoleType, KycEventLogEntity } from '@dealstack/shared/lib/generated';
import { toEventDocument } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageKYC/ReviewKycWorkflow/component/StepContent/component/RightPanel/component/History/HistoryEvents.utils';

type KycEventActor = KycEventLogEntity['userAction'];

// DC-1252: a certifier has no user session — their identity comes from the public-signer
// snapshot instead, preferring the name they actually typed over a generic role label.
const resolveKycActor = (userAction: KycEventActor): string => {
	if (userAction.userSession) {
		const { firstName, lastName } = userAction.userSession.user;
		return [firstName, lastName].filter(Boolean).join(' ');
	}
	const signer = userAction.publicSigner;
	if (!signer) {
		return '';
	}
	if (signer.fullName) {
		return signer.fullName;
	}
	const roleLabel =
		signer.role === DocumentSigningRoleType.CERTIFIER ? 'Certifier' : 'External signer';
	return signer.email ? `${roleLabel} (${signer.email})` : roleLabel;
};

const resolveKycBrowserInfo = (userAction: KycEventActor): string => {
	if (!userAction.userSession) {
		return '';
	}
	const { browserName, browserVersion, osName } = userAction.userSession;
	return `${browserName}, ${browserVersion}, ${osName}`;
};

export const mapHistoryToEvent = (
	history: KycEventLogEntity[] | undefined
): HistoryEventResult[] | undefined => {
	const historyMapped = history?.map((h) => ({
		action: mapHistoryAction(h.action, h.status),
		actor: resolveKycActor(h.userAction),
		timestamp: formatDateToUI(new Date(h.createdAt), DATE_FORMATS.DATE_TIME_ALT),
		browserInfo: resolveKycBrowserInfo(h.userAction),
		document: toEventDocument(h.file),
		status: h.status,
		comment: h.comment,
		kycFileId: h.kycFileId ?? null,
	}));
	return historyMapped;
};
